import { ServerError } from 'commerce/utils/ServerError';

export type NetworkError = {
  status?: number;
  message?: string;
};

export type FetchResponse<T> = {
  response?: T;
  error?: NetworkError;
};

export async function errorWrapper<T extends any>(
  callbackName: string,
  callback: () => Promise<T>,
): Promise<FetchResponse<T>> {
  try {
    return Promise.resolve({ response: await callback() });
  } catch (error: any) {
    let parsedError: NetworkError;
    if (error.hasOwnProperty('response')) {
      parsedError = {
        status: error.response.data.code || error.response.status,
        message: error.response.data.message || error.response.data.error,
      };
    } else if (typeof error === 'string') {
      parsedError = JSON.parse(error);
    } else {
      parsedError = error;
    }

    if (typeof window === 'undefined') {
      console.error(new ServerError(`fetch of "${callbackName}"`, parsedError));
    }

    return Promise.resolve({ error: parsedError });
  }
}
